<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Offer</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Offer</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Offer">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'OfferList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Title</label>
                    <input type="text" id="title" name="title"
                           v-bind:class="{'has-error' : errors.has('title')}"
                           v-validate="'required'"
                           v-model="value.title" class="form-control title"
                           placeholder="Title">
                    <div class="help text-danger" v-show="errors.has('title')">
                      {{ errors.first("title") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Description</label>
                    <textarea id="description" name="description"
                              v-model="value.description" class="form-control description"
                              placeholder="Description"
                              rows="3"></textarea>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Call To Action</label>
                    <input type="text" id="call_to_action" name="call_to_action"
                           v-validate="{required: {required: true}, url: {require_protocol: true }}"
                           v-model="value.call_to_action" class="form-control call_to_action"
                           placeholder="Call To Action">
                    <small class="help text-muted text-xs">Must use http or https at the beginning of the url - Ex. https://dotlines.com.sg</small>
                    <div
                      class="help text-danger"
                      v-show="errors.has('call_to_action')"
                    >
                      {{ errors.first("call_to_action") }}
                    </div>
                  </div>
                  <!--<div class="col-md-12">
                    <h4 class="site-heading my-3"><span>Thumb</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="thumb"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file"
                                   name="thumb" class="custom-file-input" id="thumb" @change="select_file_thumb">
                            <label class="custom-file-label" for="thumb">{{ value.thumb_name }}</label>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>-->

                  <div class="form-group required">
                    <label class="control-label">Display order</label>
                    <input
                      type="number"
                      id="display_order"
                      name="display_order"
                      v-model="value.display_order"
                      class="form-control"
                      placeholder="Display order"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('display_order')"
                    >
                      {{ errors.first("display_order") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Is published</label>
                    <el-select v-model="value.is_published" v-validate="'required'" name="is_published"
                               style="width: 100%" placeholder="Select published status">
                      <el-option
                        v-for="item in [{value: 'Yes', label: 'Yes'}, {value: 'No', label: 'No'}]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('is_published')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "OfferForm",
  metaInfo: {
    title: "Offer | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      display_order: 9999,
      thumb: '', thumb_name: 'Choose file'
    },
    pre: {}
  }),
  methods: {

    select_file_thumb: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.thumb = reader.result;
          this.$set(this.value, 'thumb_name', event.target.files[0].name)
        };
      } catch (e) {
        //console.log(e);
      }
    },


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/offers";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/offers/" + _this.$route.params.id
            method = "PUT";
          }


          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "OfferList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/offers/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });

        this.value.thumb = ''
      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

